export const BEESWAX_QUERY_DEBOUNCE_MS = 250;

export const BEESWAX_MAX_RETRIES = 1;

export const LOOKER_REPORT_DEBOUNCE_MS = 600;
export const ADSWIZZ_REPORT_DEBOUNCE_MS = 400;
export const ESM_REPORT_DEBOUNCE_MS = 500;
export const SIMPLIFI_REPORT_DEBOUNCE_MS = 600;
